<template>
    <va-create-layout>
        <FbaInventoryGroup-form
            :title="title"
            :item="item"
        ></FbaInventoryGroup-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
